export function sortDate(aValue, a, sortConfig, bValue, b) {
    let tmpA = aValue;
    let tmpB = bValue
    try {
        const parseDate = (dateStr) => {
            if (!dateStr) return null; // Earliest possible null value if the date is null

            const [day, month, year] = dateStr.split('/');
            return new Date(year, month - 1, day); // month is 0-based in JS Date
        };
        // Use the correct field based on sortConfig.key
        tmpA = parseDate(a[sortConfig.key]);
        tmpB = parseDate(b[sortConfig.key]);
    } catch (e) {
        console.log('Something went wrong while parsing the date in Sort function: ', e);
    }
    return { tmpA, tmpB };
}
